/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { getMonthlyMortgagePayment } from './utils';

import { CurrencySymbol } from '../../../../utils/formatters';

import { trackAdFoxMortgage } from '../../../../tracking/ad-fox-mortgage';
import { IMortgageBannerStateProps } from './mortgage-container';

import * as styles from './style.css';

export interface IMortgageBannerOwnProps {
  context: IAdFoxBannerContext;
}

export interface IMortgageBannerProps extends IMortgageBannerOwnProps, IMortgageBannerStateProps {}

export class MortgageBanner extends React.PureComponent<IMortgageBannerProps, {}> {
  public componentDidMount() {
    const {
      context: { bannerId },
      tracking: { user, page },
    } = this.props;

    trackAdFoxMortgage('show', 'BannerIpoteka', bannerId, user, page);
  }

  public render() {
    const {
      buttonTitle,
      firstInstallmentInPercent,
      imageUrl,
      months,
      price,
      rate,
      title,
      url,
      footnote,
    } = this.props.context;
    const monthlyPayment = `${numberToPrettyString(
      getMonthlyMortgagePayment({
        firstInstallmentInPercent,
        months,
        price,
        rate,
      }),
    )} ${CurrencySymbol.Rur}/мес`;

    return (
      <a
        href={url}
        target="_blank"
        rel="nofollow noopener"
        className={styles['container']}
        onClick={this.onBannerClick}
      >
        <img className={styles['logo']} src={imageUrl} width="148" />
        <div className={styles['information']}>
          <h4 className={styles['title']}>
            {title}
            <span className={styles['monthly-payment']}>{` от ${monthlyPayment}`}</span>
          </h4>
          <p className={styles['description']}>{footnote || '*Предварительный расчёт'}</p>
          <p className={styles['fake_link']}>{buttonTitle}</p>
        </div>
      </a>
    );
  }

  private onBannerClick = () => {
    const {
      context: { bannerId },
      tracking: { user, page },
    } = this.props;

    trackAdFoxMortgage('click', 'BannerIpoteka', bannerId, user, page);
  };
}
